/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetUserCouponUsedPageListRespVo } from './PageDataGetUserCouponUsedPageListRespVo';
import {
    PageDataGetUserCouponUsedPageListRespVoFromJSON,
    PageDataGetUserCouponUsedPageListRespVoFromJSONTyped,
    PageDataGetUserCouponUsedPageListRespVoToJSON,
    PageDataGetUserCouponUsedPageListRespVoToJSONTyped,
} from './PageDataGetUserCouponUsedPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetUserCouponUsedPageListRespVo
 */
export interface ResponsePageDataGetUserCouponUsedPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetUserCouponUsedPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetUserCouponUsedPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetUserCouponUsedPageListRespVo}
     * @memberof ResponsePageDataGetUserCouponUsedPageListRespVo
     */
    data?: PageDataGetUserCouponUsedPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetUserCouponUsedPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetUserCouponUsedPageListRespVo(value: object): value is ResponsePageDataGetUserCouponUsedPageListRespVo {
    return true;
}

export function ResponsePageDataGetUserCouponUsedPageListRespVoFromJSON(json: any): ResponsePageDataGetUserCouponUsedPageListRespVo {
    return ResponsePageDataGetUserCouponUsedPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetUserCouponUsedPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetUserCouponUsedPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetUserCouponUsedPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetUserCouponUsedPageListRespVoToJSON(json: any): ResponsePageDataGetUserCouponUsedPageListRespVo {
    return ResponsePageDataGetUserCouponUsedPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetUserCouponUsedPageListRespVoToJSONTyped(value?: ResponsePageDataGetUserCouponUsedPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetUserCouponUsedPageListRespVoToJSON(value['data']),
    };
}

